var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:_vm.reference,class:_vm.computedClass,attrs:{"id":_vm.id,"type":_vm.type,"disabled":!_vm.loaded || _vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_c('div',{attrs:{"id":_vm.recaptchaId,"data-size":"invisible"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }